import React, { memo, useEffect, useState, useRef } from 'react'
import CheckByPhoneModalStyle from '../CheckByPhoneModal/CheckByPhoneModalStyle'
import Modal from 'react-modal'
import { ErrorModal } from '../index'
import { get } from 'lodash'
import api, { customFuncsApi } from '../../../api'
import ClipLoader from 'react-spinners/ClipLoader'
import ImeiModal from '../InventoryTansfersModal/ImeiModal'
import moment from 'moment'
import { Empty } from 'antd'
import { useSelector } from 'react-redux'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 15,
		border: 'none',
		maxHeight: '100vh',
		width: '85%',
	},
	overlay: {
		background: '#00000099',
	},
}

const OutgoingPaymentsModal = ({
	getRef = () => {},
	onConfirm = () => {},
	onClose = () => {},
	phones = '',
}) => {
	const { getMe } = useSelector((state) => state.main)

	const [isOpenModal, setIsOpenModal] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [data, setData] = useState([])

	const imeiModalRef = useRef()
	const errorModalRef = useRef()

	useEffect(() => {
		const ref = {
			open: (t) => {
				setIsOpenModal(true)
				search(t.startDate, t.endDate)
			},
			close: () => setIsOpenModal(false),
		}
		getRef(ref)
	}, [])

	const search = (startDate, endDate) => {
		const accountsArray = [
			getMe?.U_CardUsdAccount !== null ? getMe?.U_CardUsdAccount : '',
			getMe?.U_CardAccount !== null ? getMe?.U_CardAccount : '',
			getMe?.U_CashAccount !== null ? getMe?.U_CashAccount : '',
			getMe?.U_CashUzsAccount !== null ? getMe?.U_CashUzsAccount : '',
			getMe?.U_TerminalAccount !== null ? getMe?.U_TerminalAccount : '',
			getMe?.U_TransAccount !== null ? getMe?.U_TransAccount : '',
		].filter(Boolean)

		const accounts = accountsArray.length ? JSON.stringify(accountsArray) : ''

		setIsLoading(true)
		customFuncsApi
			.get(
				`/xsSql/getExpensesByDate?date1='${startDate + 'T00:00:00.000Z'}'&date2='${endDate + 'T00:00:00.000Z'}'${get(getMe, 'Department2.Name', '') !== 'Boshqaruv' ? `&accounts=${encodeURIComponent(accounts)}` : ''}`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=100',
					},
				},
			)
			.then((res) => {
				const resData = res.data.value
				setData(resData)
				setIsLoading(false)
			})
			.catch((err) => {
				if (err)
					errorModalRef.current?.open(
						get(err.response.data, 'error.message', ''),
					)
				setIsLoading(false)
			})
	}

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => setIsOpenModal(false)}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<CheckByPhoneModalStyle>
				{isLoading ? (
					<ClipLoader
						loading={true}
						size={75}
						aria-label="Loading Spinner"
						className={'loader'}
						data-testid="loader"
					/>
				) : (
					<>
						<div className="overflow-y-auto mb-8">
							<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
								<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
									<tr>
										<th scope="col" className="px-6 py-4">
											Номер документа
										</th>
										<th scope="col" className="px-6 py-4">
											Поставщик
										</th>
										<th scope="col" className="px-6 py-4">
											Имя счета
										</th>
										<th scope="col" className="px-6 py-4">
											Валюта
										</th>
										<th scope="col" className="px-6 py-4">
											Сумма
										</th>

										<th scope="col" className="px-6 py-4">
											Дата
										</th>
									</tr>
								</thead>
								<tbody>
									{data.length > 0 ? (
										data.map((v, i) => (
											<tr
												className="bg-white border-b  hover:bg-gray-50 "
												key={i}
											>
												<td className="px-6 py-4 font-medium text-gray-900 ">
													{get(v, 'DocNum', '')}
												</td>
												<td className="px-6 py-4 whitespace-nowrap">
													{get(v, 'CardName', '')}
												</td>
												<td className="px-6 py-4">
													{get(v, 'CreditAccountName', '')}
												</td>
												<td className="px-6 py-4">{get(v, 'Currency', '')}</td>
												<td className="px-6 py-4">
													{get(v, 'Sum', '') > 0
														? new Intl.NumberFormat('fr-FR', {
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
															})
																.format(get(v, 'Sum', ''))
																.replace(',', '.')
														: new Intl.NumberFormat('fr-FR', {
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
															})
																.format(get(v, 'FCSum', ''))
																.replace(',', '.')}
												</td>
												{/* <td className="px-6 py-4">{get(v, 'CardCode', '')}</td> */}
												<td className="px-6 py-4">
													{moment(get(v, 'RefDate', '')).format('DD-MM-YYYY')}
												</td>
											</tr>
										))
									) : (
										<tr>
											<td colSpan="10">
												<Empty
													description="Нет информации!"
													image={Empty.PRESENTED_IMAGE_SIMPLE}
												/>
											</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>
						{/* <div className="topCard">
							<div style={{ alignItems: 'center' }} className="flex">
								<Button onClick={oldData} btnStyle={{ marginRight: 10 }}>
									{'<'}
								</Button>
								<p style={{ marginRight: '10px' }}>{pagination.page + 1}</p>
								<Button onClick={newDatas}>{'>'}</Button>
							</div>
							<div className="btn-box" style={{ display: 'flex', gap: '15px' }}>
								<Button
									btnStyle={{ width: 'max-content', padding: '0 10px' }}
									onClick={() => window.open('/pay-supplier', '_blank')}
								>
									Оплата поставщику
								</Button>
								<Button
									btnStyle={{ width: 'max-content', padding: '0 10px' }}
									onClick={() => window.open('/constant-consumption', '_blank')}
								>
									Постоянные расходы
								</Button>
							</div>
						</div> */}
					</>
				)}

				<ErrorModal getRef={(r) => (errorModalRef.current = r)} />
				<ImeiModal getRef={(r) => (imeiModalRef.current = r)} />
			</CheckByPhoneModalStyle>
		</Modal>
	)
}

export default memo(OutgoingPaymentsModal)
